export interface SieveSortField {
    name: string;
    order: 'asc' | 'desc'
}

export interface SieveFilterByField {
    name: string;
    comparator: SIEVE_FIELD_COMPARATOR;
    values: string[];
    matchAllValues: boolean;
}

export interface AdvancedSieveFilterByFields {
   filters: Array<SieveFilterByField>,
   type: SieveFilterType
}

export interface SieveOrFilterByFields {
    names: string[];
    comparator: SIEVE_FIELD_COMPARATOR;
    value: string;
}

export enum SIEVE_FIELD_COMPARATOR {
    EQUALS = "==",
    NOT_EQUALS = "!=",
    GREATER_THAN = ">",
    LESS_THAN = "<",
    GREATER_THAN_OR_EQUAL_TO = ">=",
    LESS_THAN_OR_EQUAL_TO = "<=",
    CONTAINS = "@=",
    STARTS_WITH = "_=",
    ENDS_WITH = "_-=",
    DOES_NOT_CONTAINS = "!@=",
    DOES_NOT_STARTS_WITH= "!_=",
    DOES_NOT_ENDS_WITH= "!_-=",
    CASE_INSENSITIVE_STRING_CONTAINS= "@=*",
    CASE_INSENSITIVE_STRING_BEGINS_WITH= "_=*",
    CASE_INSENSITIVE_STRING_ENDS_WITH= "_-=*",
    CASE_INSENSITIVE_STRING_EQUALS= "==*",
    CASE_INSENSITIVE_STRING_NOT_EQUALS= "!=*",
    CASE_INSENSITIVE_STRING_DOES_NOT_CONTAINS= "!@=*",
    CASE_INSENSITIVE_STRING_DOES_NOT_STARTS_WITH= "!_=*"
}

export interface SieveSearchRequestQuery {
    filters?: SieveFilterByField[],
    orFilters?: SieveOrFilterByFields[],
    sortOrders?: SieveSortField[],
    advancedFilters?: AdvancedSieveFilterByFields[]
}

export type SieveFilterType = "AND" | "OR"